import axios from 'axios';
import actions from './actions';
import { appOperations } from '../../../../../App/store';
import ColoredSnackbarConstants from '../../../../misc/ColoredSnackbar/ColoredSnackbarConstants';

const { setExportsInfo, setLoading } = actions;
const { openSnack } = appOperations;

const fetchExportsQueue = () => async (dispatch) => {
    dispatch(setLoading(true));
    try {
        const response = await axios.get('/api/admin/Export/GetExportsQueueInfo');
        const { exportsInfo } = response.data;
        dispatch(setExportsInfo(exportsInfo || {
            pendingExports: [],
            runningExports: [],
            completedExports: []
        }));
    } catch (error) {
        console.error("Error fetching exports queue:", error);
        dispatch(openSnack('Failed to fetch exports queue', ColoredSnackbarConstants.SNACKBAR_ERROR));
    } finally {
        dispatch(setLoading(false));
    }
};

export default { fetchExportsQueue };
